const useLocalStorage = () => {
  const getBoolean = (name) => {
    let value = false

    try {
      value = window.localStorage.getItem(name) === '1'
    } catch (e) { }

    return value
  }

  const setBoolean = (name, value) => {
    try {
      value = window.localStorage.setItem(name, value ? '1' : '0')
    } catch (e) { }

    return value
  }

  return {
    getBoolean,
    setBoolean,
  }
}

export default useLocalStorage
